import * as yup from 'yup';

const BasicContactValidation = yup.object()
  .shape({
    breeder_name: yup
      .string()
      .max(15, 'Name must be less than 15 characters'),
    breeder_phone: yup
      .string()
      .nullable()
      .test('valid-phone', 'Please enter a valid phone number.', (value) => {
        if (value && value.length === 10) {
          return yup.string()
            .isValidSync(value);
        }
        return true; // No error if length is not 10
      })
      .test('phone-length', 'Phone number must be 10 digits', (value) => {
        if (value) {
          return value.length === 10;
        }
        return true; // No error if value is empty
      }),
    category: yup
      .string()
      .required('Category is required'),
    email: yup
      .string()
      .email()
      .required('Email is required'),
    message: yup
      .string()
      .max(1000, 'Message must be less than 1000 characters')
      .required('Message is required'),
    name: yup
      .string()
      .max(80, 'Name must be less than 80 characters')
      .required('Name is required'),
  });

export default BasicContactValidation;
